(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.faceDatabase', {
      url: '/face-database',
      template: `<new-front-container path="'face-database'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.FaceDatabase" | translate}}',
      },
    });
  }
})();
